import React from "react";
import { Eye, EyeOff, X } from "lucide-react";

const CredenciaisModal = ({
  isOpen,
  credenciaisForm,
  showSenha,
  savingCredenciais,
  onClose,
  onChange,
  onSubmit,
  onToggleShowSenha,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-border">
          <h2 className="text-base font-semibold text-foreground">Corrigir dados de acesso</h2>
          <button
            type="button"
            className="text-muted-foreground hover:text-foreground transition-colors"
            onClick={onClose}
            disabled={savingCredenciais}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="p-5 flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-foreground" htmlFor="nome">Domínio</label>
              <input
                id="nome"
                name="nome"
                type="text"
                className="w-full px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-60"
                value={credenciaisForm.nome}
                onChange={onChange}
                disabled={savingCredenciais}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-foreground" htmlFor="login">Usuário</label>
              <input
                id="login"
                name="login"
                type="text"
                className="w-full px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-60"
                value={credenciaisForm.login}
                onChange={onChange}
                disabled={savingCredenciais}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-foreground" htmlFor="senha">Senha</label>
              <div className="relative">
                <input
                  id="senha"
                  name="senha"
                  type={showSenha ? "text" : "password"}
                  className="w-full px-3 py-2 pr-10 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-60"
                  value={credenciaisForm.senha}
                  onChange={onChange}
                  disabled={savingCredenciais}
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                  onClick={onToggleShowSenha}
                  disabled={savingCredenciais}
                >
                  {showSenha ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-2 p-5 border-t border-border">
            <button
              type="button"
              className="px-4 py-2 text-sm font-medium rounded-md border border-border text-foreground hover:bg-slate-50 transition-colors disabled:opacity-60"
              onClick={onClose}
              disabled={savingCredenciais}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors disabled:opacity-60"
              disabled={savingCredenciais}
            >
              {savingCredenciais ? "Salvando..." : "Salvar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CredenciaisModal;
